import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { createDriver, editDriver, resetCreateDriver, resetEditDriver } from '../../actions/dispatch_actions';
import DriverForm from '../../components/Dispatch/driverForm';

function mapStateToProps(state) {
  return {
    currentDriver: state.dispatch.currentDriver,
    initialValues: state.dispatch.currentDriver,
    isCreating: state.dispatch.isCreating,
    createError: state.dispatch.createError,
    created: state.dispatch.created,
    isEditing: state.dispatch.isEditing,
    editError: state.dispatch.editError,
    edited: state.dispatch.edited,
  };
}

// const validate = (values) => {
//   const errors = {};
//   if (!values.Name) {
//     errors.Name = 'Required';
//   }
//   if (!values.TermDays) {
//     errors.TermDays = 'Required';
//   } else if (isNaN(Number(values.TermDays))) {
//     errors.TermDays = 'Term Days should be a number.';
//   }
//   if (!values.Termtype) {
//     errors.Termtype = 'Required';
//   }
//   return errors;
// };

const driverForm = reduxForm({
  form: 'driverForm',
  // validate,
})(DriverForm);

export default connect(mapStateToProps, {
  createDriver, editDriver, resetCreateDriver, resetEditDriver,
})(driverForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/driverForm.jsx